import { render } from "./ListDocuProjLink.vue?vue&type=template&id=35ee3fe9"
import script from "./ListDocuProjLink.vue?vue&type=script&lang=js"
export * from "./ListDocuProjLink.vue?vue&type=script&lang=js"

import "./ListDocuProjLink.vue?vue&type=style&index=0&id=35ee3fe9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__